<template>
  <div
    id="bodyModal"
    v-if="this.folder"
  >
    <div id="header">
      <b-input v-model="editedName"></b-input>
    </div>
    <div id="listingPosts">
      <b-table
        :data="this.folder.posts"
        style="overflow-x: auto;max-height: 50vh;"
      >
        <template slot-scope="props">
          <b-table-column
            field="couleur"
            :label="$t('group.couleur')"
            width="10"
          >
            <div
              :style="`background-color:${colorNum == null ?props.row.couleur: colors[colorNum] };`"
              class="colorCircle"
            ></div>
          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('group.contenu')"
            width="40"
          >
            {{ props.row.contenu }}
          </b-table-column>
        </template>
      </b-table>
    </div>

    <form
      id="changes"
      @submit.prevent="sendChanges"
    >
      <div id="changeColor">

        <p id="colorSelect">{{$t('group.editColor')}}</p>
        <div
          id="groupEditColorCont"
          v-if="colors"
        >
          <div
            v-for="(color, key ) in colors"
            :style="`background-color: ${color};`"
            @click="colorNum === key ? colorNum =null :colorNum = key"
            class="colorPicker"
            :class="colorNum === key ? 'selected':''"
            :key="key"
            v-if=" key< colors.length - 2"
          ></div>
        </div>
      </div>
      <div id="changeSheet">
        <p id="sheetSelect">{{$t('group.editSheet')}}</p>

        <b-select
          icon="book-open"
          id="groupEditSheet"
          :value="this.currentSheet"
        >
          <option
            v-for="sheet in this.current.sheets"
            :key="sheet.id"
            :value="sheet.id"
          >
            {{sheet.name}}
          </option>
        </b-select>
      </div>

      <div id="actionButtons">
        <button
          class="button is-danger"
          type="button"
          @click='selfClose'
        >
          {{$t('dialog.cancel')}}
        </button>
        <button
          class="button is-success"
          type="submit"
        >{{$t('dialog.confirm')}}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('board')

export default {
  name: 'EditFolder',
  data () {
    return {
      colors: this.$parent.$parent.colors,
      colorNum: this.$parent.$parent.$parent.colorNum,
      editedName: this.folder.name
    }
  },
  props: {
    folder: Object
  },
  computed: {
    ...mapState({
      currentSheet: 'currentSheet',
      current: 'current',
      menu: 'menu',
      postlist: 'currentBoardPost',
      linking: 'linking'
    })
  },
  methods: {
    sendChanges (e) {
      // console.log(e)
      let posts = this.folder.posts // gather all the selected posts
      posts.forEach(post => {
        if (this.colorNum !== null) {
          post.couleur = this.colors[this.colorNum] // change their colors
        }
        post.sheet_id = parseInt(document.querySelector('#groupEditSheet').value)
      })
      this.folder.sheet_id = parseInt(document.querySelector('#groupEditSheet').value) // change their sheet

      fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/post`, { // sends them
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(posts)
      }).then(res => {
        let url = `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder/${this.folder.id}`
        this.folder.name = this.editedName
        let data = JSON.parse(JSON.stringify(this.folder))
        fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
          },
          body: JSON.stringify(data)
        }
        )
      })

      this.selfClose()// turn off multi-editing
      this.colorNum = null
    },
    selfClose () {
      this.$parent.$parent.editFolderActive = false
    }
  }

}
</script>

<style scoped>
#bodyModal {
  margin-top: 10vh;
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  padding: 10px 20px;
  background: #fff;
  border-radius: 8px;
}
#header {
  max-width: 60%;
  margin: auto;
  width: 60%;
}
.colorCircle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
#colorSelect {
  text-align: left;
}
#groupEditColorCont {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-content: center;
  padding: 0px 95px;
  margin-bottom: 15px;
}
.colorPicker {
  width: 40px;
  height: 40px;
  margin: 5px 5px;
  border-radius: 50%;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
#sheetSelect {
  text-align: left;
  margin: 8px auto;
}

.selected {
  border: 3px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/board/modal/EditFolderPopup.vue